import axios from "axios";
import config from "../config";
import router from "../src/router";
import { Message } from "element-ui";
// axios.defaults.baseURL = 'http://brightness.mynetgear.com:8081/hz/';
// axios.defaults.baseURL = 'http://hz.richcyber.com:8081/hz/';
axios.defaults.baseURL = config.axiosBaseUrl;
const VR_URL = config.vrUrl;
axios.interceptors.request.use((config) => {
  if (
    config.url == "/apiaccount/signin" ||
    config.url == "/apiaccount/logout"
  ) {
    config.baseURL = VR_URL;
  } else {
    const token = localStorage.getItem("token");
    config.headers.token = token;
  }

  return config;
}),
  (error) => {
    return Promise.error(error);
  };
axios.interceptors.response.use((response) => {
  const code = response.data.code;
  if (code == 4003 && window.localStorage.getItem('token')) {
    window.localStorage.clear();
    window.localStorage.setItem('tokenError',true)
    router.push("/adminLogin");
    Message({
      message: "您的登陆已过期，请重新登录",
      type: "warning",
    });
  }
  return response;
}),
  (error) => {
    return Promise.error(error);
  };
export default axios;
